module.exports = __webpack_public_path__ + "static/img/pin-no-activity-scheduled.e2b89cb.svg";